import React, { Component, Fragment } from 'react';

class Elucidation extends Component {

  render() {

    const {
      symbol,
      text
    } = this.props

    return (
      <Fragment>
        { symbol &&
          <div className="elucidation">
            <div className="elucidation__inner">
              {symbol}
            </div>
            <div className="elucidation__hidden">
              {text}
            </div>
          </div>
        }
      </Fragment>
    )

  };
}

export default Elucidation;



// WEBPACK FOOTER //
// ./src/components/Elucidation/Elucidation.js